var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:['status-chip', `status-chip--${_vm.status}`],attrs:{"small":"","label":""}},[_c('v-icon',{class:{ 'spin-icon': _vm.status === 'andamento' },attrs:{"left":"","size":"14"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }